import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  ComposableMap,
  ZoomableGroup,
  Geographies,
  Geography,
} from "react-simple-maps";
import geoUrl from "./worldmap.json";
import { IRepresentacion } from "../../../../interfaces/Representacion";

const countryMappings: { [key: string]: string } = {
  ATG: "2A",
  ARG: "4A",
  BHS: "2M",
  BRB: "2B",
  BLZ: "1B",
  BOL: "3B",
  BRA: "4B",
  CAN: "5C",
  CHL: "4C",
  COL: "3C",
  CRI: "1C",
  DMA: "2D",
  ECU: "3E",
  SLV: "1S",
  USA: "5E",
  GRD: "2R",
  GTM: "1G",
  GUY: "2G",
  HTI: "2H",
  HND: "1H",
  ESP: "5H",
  JAM: "2J",
  MEX: "5M",
  NIC: "1N",
  PAN: "1P",
  PRY: "4P",
  PER: "3P",
  DOM: "2P",
  KNA: "2K",
  VCT: "2V",
  LCA: "2L",
  SUR: "2S",
  TTO: "2T",
  URY: "4U",
  VEN: "3V",
};

const highlighted_countries = [
  "ATG",
  "ARG",
  "BRB",
  "BOL",
  "BRA",
  "BHS",
  "BLZ",
  "CAN",
  "CHL",
  "COL",
  "CRI",
  "DMA",
  "DOM",
  "ECU",
  "GRD",
  "GTM",
  "GUY",
  "HND",
  "HTI",
  "JAM",
  "KNA",
  "LCA",
  "MEX",
  "NIC",
  "PAN",
  "PER",
  "PRY",
  "SUR",
  "SLV",
  "TTO",
  "USA",
  "URY",
  "VCT",
  "VEN",
  "ESP",
];

interface Position {
  coordinates: [number, number];
  zoom: number;
}

const WorldMap:React.FC<{ pais?: IRepresentacion, setPaisFromCode: (code:string) => void }> = ({ pais, setPaisFromCode }) => {

  const [position, setPosition] = useState<Position>({
    coordinates: [-80, 40],
    zoom: 1,
  });

  const [selectedCountry, setSelectedCountry] = useState<string>()

  useEffect(() => {
    setSelectedCountry(Object.keys(countryMappings).find(key => countryMappings[key] === pais?.codigo_Unidad));
  }, [pais])

  function handleZoomIn() {
    if (position.zoom >= 5) return;
    setPosition((pos) => ({ ...pos, zoom: pos.zoom * 2 }));
  }

  function handleZoomOut() {
    if (position.zoom <= 1) return;
    setPosition((pos) => ({ ...pos, zoom: pos.zoom / 2 }));
  }

  function handleMoveEnd(position: Position) {
    setPosition(position);
  }

  const handleCountryClick = (geo:any) => {
    console.log(geo.id)
    setSelectedCountry(geo.id);
  }

  return (
    <>
      <ComposableMap
        projection="geoMercator"
        style={{ maxHeight: "80vh", width: "100%" }}
      >
        <ZoomableGroup
          zoom={position.zoom}
          center={position.coordinates}
          onMoveEnd={handleMoveEnd}
        >
          <Geographies geography={geoUrl}>
            {({ geographies }) =>
              geographies.map((geo, key) => {
                const isHighlighted =
                  highlighted_countries.indexOf(geo.id) !== -1;
                const isSelected = selectedCountry === geo.id;
                return (
                  <OverlayTrigger
                    key={key}
                    placement={"auto"}
                    overlay={
                      <Tooltip id={`tooltip-${geo.rsmKey}`}>
                        <strong>{geo.properties.name}</strong>
                      </Tooltip>
                    }
                  >
                    <Geography
                      geography={geo}
                      onClick={() => {
                        setPaisFromCode(countryMappings[geo.id])
                        handleCountryClick(geo)
                        //console.log(`El país es: ${countryMappings[geo.id]}`)
                      }}
                      enableBackground={"red"}
                      style={{
                        default: {
                          fill: isHighlighted ? isSelected ? "#28a745": "#5780b5" : "#e9ecef",
                          stroke: isHighlighted ? "#466185" : "#9d9d9d",
                          strokeWidth: "0.3",
                          userSelect: "none",
                          outline: "none",
                          transition: ".1s ease-in-out .1s",
                          pointerEvents: isHighlighted ? "auto" : "none",
                        },
                        hover: {
                          fill: "#1c3664",
                          stroke: "#466185",
                          strokeWidth: "0.3",
                          outline: "none",
                          cursor: "pointer",
                        },
                      }}
                    />
                  </OverlayTrigger>
                );
              })
            }
          </Geographies>
        </ZoomableGroup>
      </ComposableMap>
      <div className="text-end" style={{ marginTop: "-2rem" }}>
        <button className="btn btn-light me-2" onClick={handleZoomIn}>
          <FontAwesomeIcon icon={faPlus} />
        </button>
        <button className="btn btn-light" onClick={handleZoomOut}>
          <FontAwesomeIcon icon={faMinus} />
        </button>
      </div>
    </>
  );
};

export default WorldMap;
